import { generateOrderLines } from "../gtmHelper";
import { pushGTMInternal } from "../pushGtmEvents";

export const gtmTrackAddDipFromBasket = (self, {productSelections}, groupId, eventName) => {
	try {
		const productCatalog = self.$store.getters.productCatalog;
		const orderLine = (generateOrderLines(self, {productCatalog, productSelections}) || [])[0];
		if(!orderLine) return;
		const dipsOL = orderLine.subLines.find(ol2 => ol2._source && ol2._source.id === groupId);
		if (dipsOL && dipsOL.totalPriceAccum) {
			pushGTMInternal(
				eventName,
				self.product.name,
				self.$route.path,
				"",
				{
					email: (self.$store.getters.personData || {}).email,
					selectedRestaurant: (self.globalSelectedShop || {}).shopName,
					upsellValue: dipsOL.totalPriceAccum
				}
			);
		}
	} catch(e) {
		// even if something fails in this block, we should proceed
	}
};
